import { request } from './apiClient'

export const fetchOffer = () =>
  request('GET', '/v1/offer')
